import { render, staticRenderFns } from "./only_goods_details.vue?vue&type=template&id=54f8c3d0&scoped=true"
import script from "./only_goods_details.vue?vue&type=script&lang=js"
export * from "./only_goods_details.vue?vue&type=script&lang=js"
import style0 from "./only_goods_details.vue?vue&type=style&index=0&id=54f8c3d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8c3d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f8c3d0')) {
      api.createRecord('54f8c3d0', component.options)
    } else {
      api.reload('54f8c3d0', component.options)
    }
    module.hot.accept("./only_goods_details.vue?vue&type=template&id=54f8c3d0&scoped=true", function () {
      api.rerender('54f8c3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/source/only_goods_details.vue"
export default component.exports